import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { GATEWAY_BASE_PATH } from 'lib-services';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule],
  providers: [
    { provide: GATEWAY_BASE_PATH, useValue: environment.dxtBasePath },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}